import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { InvestorProfileFundingSource } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { InvestorProfileFormData } from '../types';
export const FundingSourcesSection = () => {
  const $ = _c(47);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectInvestorProfile.fundingSources"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      label: t1,
      value: "employment_income"
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      label: t3,
      value: "investments"
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      label: t5,
      value: "inheritance"
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp4);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      label: t7,
      value: "business_income"
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp5);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      label: t9,
      value: "savings"
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp6);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      label: t11,
      value: "family"
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t2 || $[28] !== t4 || $[29] !== t6 || $[30] !== t8) {
    t13 = [t2, t4, t6, t8, t10, t12];
    $[25] = t10;
    $[26] = t12;
    $[27] = t2;
    $[28] = t4;
    $[29] = t6;
    $[30] = t8;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const options = t13;
  let t14;
  if ($[32] !== t) {
    t14 = t(_temp7);
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14) {
    t15 = <h2 className="text-label-2 text-primary">{t14}</h2>;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = diToFormData("investor_profile.funding_sources");
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t(_temp8);
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t17) {
    t18 = {
      required: t17
    };
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== options || $[42] !== t18) {
    t19 = <Form.CheckboxGroup name={t16} options={options} rules={t18} className="flex flex-col gap-4" />;
    $[41] = options;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t15 || $[45] !== t19) {
    t20 = <section className="flex flex-col gap-6">{t15}{t19}</section>;
    $[44] = t15;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  return t20;
};
export default FundingSourcesSection;
function _temp($) {
  return $.employmentIncome;
}
function _temp2($_0) {
  return $_0.investments;
}
function _temp3($_1) {
  return $_1.inheritance;
}
function _temp4($_2) {
  return $_2.businessIncome;
}
function _temp5($_3) {
  return $_3.savings;
}
function _temp6($_4) {
  return $_4.family;
}
function _temp7($_5) {
  return $_5.title;
}
function _temp8($_6) {
  return $_6.emptySelection;
}